import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-full-loading',
    imports: [CommonModule],
    templateUrl: './full-loading.component.html',
    styleUrls: ['./full-loading.component.scss']
})
export class FullLoadingComponent {
  @Input('backdrop') backdropProps: boolean | undefined = false;
  @Input('blur') blurProps: boolean | undefined = false;
}
